import React, { useEffect } from "react";

import "./activeOrders.css";

import { ActiveOrder } from "../_common/ActiveOrder";

const sortOrders = (a, b) => {
  let A = a.orderDate;
  let B = b.orderDate;

  if (A > B) {
    return -1;
  } else if (B > A) {
    return 1;
  } else {
    return 0;
  }
};

const ActiveOrders = ({
  activeOrders,
  isActiveOrdersLoading,
  handleUpdateOrderAdmin,
  handleUpdateOrderChef,
  handleConfirmOrder,
  handleInactivateOrder
}) => {
  return (
    <>
      {isActiveOrdersLoading ? (
        <div className="activeOrdersLoadingSpinner">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      ) : null}
      <div className="subSection activeOrdersSubsection">
        <h3></h3>
        {activeOrders.length ? (
          activeOrders
            .sort(sortOrders)
            .map((order) => (
              <ActiveOrder
                order={order}
                key={order._id}
                handleUpdateOrderAdmin={handleUpdateOrderAdmin}
                handleUpdateOrderChef={handleUpdateOrderChef}
                handleConfirmOrder={handleConfirmOrder}
                handleInactivateOrder={handleInactivateOrder}
              />
            ))
        ) : !isActiveOrdersLoading ? (
          <div className="activeOrdersSubsection__emptyMessageDiv">
            <h2>No active orders</h2>
          </div>
        ) : null}
      </div>
    </>
  );
};

export default ActiveOrders;
